import { ADDTOCARD, INCREMENT_PRODUCT, DECREMENT_PRODUCT } from "./actionTypes";

const initialState = {
  products: [
    {
      id: 1,
      name: "Think In a Redux Way",
      quantity: 10,
      price: 35,
    },
    {
      id: 2,
      name: "Python",
      quantity: 35,
      price: 99,
    },
    {
      id: 3,
      name: "Think In a React Way",
      quantity: 72,
      price: 36,
    },
  ],
  cardProducts: [],
  totalPrice: 0,
};

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDTOCARD:
      const { payload } = action;
      // console.log(payload)
      const item = state.cardProducts.find(
        (product) => product.id === payload.id
      );

      if (item) {
        return {
          ...state,
          cardProducts: state.cardProducts.map((item) =>
            item.id === payload.id
              ? {
                  ...item,
                  stockQuantity: item.stockQuantity - 1,
                  quantity: item.quantity + 1,
                }
              : item
          ),
          products: state.products.map((item) =>
            item.id === payload.id
              ? {
                  ...item,
                  quantity: item.quantity - 1,
                }
              : item
          ),
          totalPrice: state.totalPrice + payload.price,
        };
      }

      return {
        ...state,
        cardProducts: [
          ...state.cardProducts,
          {
            id: payload.id,
            name: payload.name,
            quantity: 1,
            stockQuantity: payload.quantity,
            price: payload.price,
          },
        ],
        products: state.products.map((item) =>
          item.id === payload.id
            ? {
                ...item,
                quantity: item.quantity - 1,
              }
            : item
        ),
        totalPrice: state.totalPrice + payload.price,
      };

    case INCREMENT_PRODUCT:
      const quantityIncrementItem = state.cardProducts.find(
        (product) => product.id === action.payload.id
      );

      if (quantityIncrementItem) {
        return {
          ...state,
          cardProducts: state.cardProducts.map((item) =>
            item.id === action.payload.id
              ? {
                  ...item,
                  quantity: item.quantity + 1,
                  stockQuantity: item.stockQuantity - 1,
                }
              : item
          ),
          products: state.products.map((item) =>
            item.id === action.payload.id
              ? {
                  ...item,
                  quantity: item.quantity - 1,
                }
              : item
          ),
          totalPrice: state.totalPrice + action.payload.price,
        };
      }

      return {
        ...state,
        cardProducts: [
          ...state.cardProducts,
          {
            id: action.payload.id,
            name: action.payload.name,
            quantity: 1,
            stockQuantity: payload.quantity,
            price: action.payload.price,
          },
        ],
        totalPrice: state.totalPrice + action.payload.price,
      };

    case DECREMENT_PRODUCT:
      const quantityDecrementItem = state.cardProducts.find(
        (product) => product.id === action.payload.id
      );

      if (quantityDecrementItem) {
        return {
          ...state,
          cardProducts: state.cardProducts.map((item) =>
            item.id === action.payload.id
              ? {
                  ...item,
                  quantity: item.quantity - 1,
                  stockQuantity: item.stockQuantity + 1,
                }
              : item
          ),
          products: state.products.map((item) =>
            item.id === action.payload.id
              ? {
                  ...item,
                  quantity: item.quantity + 1,
                }
              : item
          ),
          totalPrice: state.totalPrice - action.payload.price,
        };
      }

      return {
        ...state,
        cardProducts: [
          ...state.cardProducts,
          {
            id: action.payload.id,
            name: action.payload.name,
            quantity: 1,
            stockQuantity: payload.quantity,
            price: action.payload.price,
          },
        ],
        totalPrice: state.totalPrice + action.payload.price,
      };

    default:
      return state;
  }
};

export default productsReducer;
